// jQuery will be loaded from CDN, next line is here to satisfy bootstrap.js
import jQuery from "jquery";
// Exposing jQuery to window object
window.$ = window.jQuery = jQuery;



// Selective bootstrap.js build
import "bootstrap/js/dist/util";
//import 'bootstrap/js/dist/alert';
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "slick-carousel/slick/slick.js";

//import "owl.carousel/dist/owl.carousel.min.js";
//import owlCarousel from "owl.carousel/dist/owl.carousel.js";
//import "owl.carousel/dist/owl.carousel.min"
//window.owlCarousel = owlCarousel;

//console.log('owl object - ',owlCarousel)
// We will extract all css to a separate file
require("../sass/vendor.scss");
require("../sass/app.scss");
